import { render } from "./NotFound.vue?vue&type=template&id=2ea13af4&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=2ea13af4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2ea13af4"

export default script